import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const seeDetails = (
    <FormattedMessage id="global.seeDetailsCta" defaultMessage="See details" />
);

export const FollowSearch = ({ searchName, searchNameClassname }) => (
    <FormattedMessage
        id="global.followSearch"
        defaultMessage="Follow {searchName} to receive alerts when new items arrive"
        values={{
            searchName: <span className={searchNameClassname || ''}>{searchName}</span>,
        }}
    />
);

FollowSearch.propTypes = {
    searchName: PropTypes.string.isRequired,
    searchNameClassname: PropTypes.string,
};

export const viewMore = <FormattedMessage id="global.viewMore" defaultMessage="View More" />;

export const viewSimilarItems = (
    <FormattedMessage id="global.viewSimilarItems" defaultMessage="View Similar Items" />
);

export const youMayAlsoLike = (
    <FormattedMessage id="global.youMayAlsoLike" defaultMessage="You May Also Like" />
);

export const visuallySimilar = (
    <FormattedMessage id="global.visuallySimilar" defaultMessage="Visually Similar" />
);

export const moreForYourProject = (
    <FormattedMessage id="global.complementaryItems" defaultMessage="Complete the Look" />
);

export const showMoreForProject = (
    <FormattedMessage id="global.complementaryItems.showMore" defaultMessage="View More" />
);

export const showLessForProject = (
    <FormattedMessage id="global.complementaryItems.showLess" defaultMessage="View Less" />
);

export const moreFromThisSeller = (
    <FormattedMessage id="global.moreFromThisSeller" defaultMessage="More From This Seller" />
);

export const feesLimitsApply = (
    <FormattedMessage id="global.feesLimitsApply" defaultMessage="Fees and limitations apply." />
);

export const learnMore = <FormattedMessage id="global.learnMore" defaultMessage="Learn More" />;

export const buyerProtection = (
    <FormattedMessage
        id="global.buyerProtectionTitleGuaranteed"
        defaultMessage="All purchases are covered by our Buyer Protection Guarantee."
    />
);

export const email = <FormattedMessage id="global.email" defaultMessage="Email" />;

export const UnpurchasableHeader = ({ title }) => (
    <FormattedMessage
        values={{ title }}
        id="global.unpurchasableHeader"
        defaultMessage="This {title} is no longer available."
    />
);
UnpurchasableHeader.propTypes = {
    title: PropTypes.node.isRequired,
};

export const ItemsSimilarToHeader = ({ title }) => (
    <FormattedMessage
        values={{ title }}
        id="global.itemsSimilarToHeader"
        defaultMessage="Items Similar to {title}"
    />
);
ItemsSimilarToHeader.propTypes = {
    title: PropTypes.node.isRequired,
};

export const recentlyViewed = (
    <FormattedMessage id="global.recentlyViewed" defaultMessage="Recently Viewed" />
);

export const viewAllFromSeller = (
    <FormattedMessage
        id="pdp.PdpMobileDealerItems.view_all"
        defaultMessage="View All From Seller"
    />
);

export const startConversationMessage = (
    <FormattedMessage id="global.starConversation" defaultMessage="Ask the Seller" />
);

export const sellerIsHereToHelpMessage = (
    <FormattedMessage
        id="global.questionsSellerIsHereToHelp"
        defaultMessage="Questions about this piece?"
    />
);

export const itemStatus = <FormattedMessage id="global.itemStatus" defaultMessage="Item Status:" />;
